import { FormikValues } from "formik"
import { MenuItem } from "@mui/material"
import { StringKeyOf } from "../../../../../lib/lang"
import { useMerchant } from "../../../../merchants/merchantHooks"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { FormikDropdown } from "../../../../../shared/components/forms/Formik"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import {
    DeliveryLocationsQuery,
    DeliveryLocationsResponse,
    fetchDeliveryLocations,
} from "../../deliveryLocations/deliveryLocationsApi"

function selectDeliveryLocations(data: DeliveryLocationsResponse) {
    return data.deliveryLocations || []
}

type FormikDeliveryLocationFieldProps<Values extends FormikValues> = Readonly<{
    name: StringKeyOf<Values>
}>

export function FormikDeliveryLocationField<Values extends FormikValues>({
    name,
}: FormikDeliveryLocationFieldProps<Values>) {
    const { merchantId } = useMerchant()

    const { data: deliveryLocations = [] } = useApiQuery(fetchDeliveryLocations, {
        queryName: DeliveryLocationsQuery.LIST,
        dependencies: { merchantId },
        select: selectDeliveryLocations,
    })

    return (
        <LocalizedStrict id="product-create-delivery-deliveryDetails-field" attrs={{ label: true }}>
            <FormikDropdown name={name} label="Delivery" fullWidth>
                {deliveryLocations.map((location) => (
                    <MenuItem key={location.id} value={location.id}>
                        {location.displayName}
                    </MenuItem>
                ))}
            </FormikDropdown>
        </LocalizedStrict>
    )
}
